// extracted by mini-css-extract-plugin
export default {"ratingStyle":"ListingCardSm_ratingStyle__MvDC8","gapStyle":"ListingCardSm_gapStyle__XOL6M","textStyle":"ListingCardSm_textStyle__eg-QI"};